export enum VacationDayKind {
  UNKNOWN = 'UNKNOWN',
  GANZTAGS = 'GANZTAGS',
  HALBTAGS_VORMITTAG = 'HALBTAGS_VORMITTAG',
  HALBTAGS_NACHMITTAG = 'HALBTAGS_NACHMITTAG',
}
